enum SessionStorageKeyEnum {
  JWTTokens = 'jwtTokens',
  MasterPasswordHash = 's'
}

export default SessionStorageKeyEnum;
